/**
 * Take an array of objects and remove duplicate objects by parameter (key)
 *
 * @param data
 * @param key
 */
export const removeDuplicates = <T extends object, K extends keyof T>(data: Array<T>, key: K): Array<T> => {
	return data.filter((item: T, index: number, self:  Array<T>) => {
		return index === self.findIndex((innerItem: T) => innerItem[key] === item[key]);
	});
}
